import { capitalizeFirstChar } from "src/utils/l10n"

export function prettifyApiFieldValue(value: string) {
  return capitalizeFirstChar(value.replace("_", " "))
}
